import { mapActions } from 'vuex';
import refineHistory from '@/components/account/history/trades/refine-history/refine-history.vue';
import buttonWithInfo from '@/components/account/history/trades/button-with-info/button-with-info.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    value: Object,
    markets: Array,
    recent: Boolean,
    isOpen: Boolean,
  },
  components: {
    refineHistory,
    buttonWithInfo,
  },
  computed: {
    openModifier() {
      return {
        'history-filters--open': this.isOpen,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onRecent() {
      this.$emit('input', null);
      if (!this.value) {
        this.$router.push({ name: 'account-history', params: {}, query: { tabId: 'trades' } });
      } else {
        this.$router.push({ name: 'account-history', params: { marketId: 'all' }, query: { tabId: 'trades' } });
      }
    },
    onMarkets() {
      this.$router.push({ name: 'account-history', params: { marketId: 'all' }, query: { tabId: 'trades' } });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_TRADE_INFO);
    },
    onRefineHistoryInput(e) {
      this.$emit('input', e);
      this.$router.push({ name: 'account-history', params: { marketId: e.marketId }, query: { tabId: 'trades' } });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/history-filters/history-filters.js